<script>
import ModuleTitle from '../common/ModuleTitle.vue'

import { getShadowColor, getPageThemeColor } from '@/utils/modules/getStyles'

export default {
  name: 'Comp31',
  components: { ModuleTitle },
  props: {
    moduleOption: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      currentCommunity: localStorage.getItem('currentCommunity'),
      path: this.$route.path
    }
  },
  methods: {
    getShadowColor, getPageThemeColor,
    onModuleItem(v) {
      this.$emit('onModuleItem', v)
    }
  }
}
</script>

<template>
  <div class="modules-id-31">
    <!-- :style="{visibility: moduleOption.titleShow ? 'visible' : 'hidden'}" -->
    <module-title :title="moduleOption.title" margin-bottom="28" />
    <div class="comp-transverse-2 modules-id-31-content pointer">
      <!-- <p class="subtitle">{{ moduleOption.subtitle }}</p> -->
      <div class="right-list">
        <div
          v-for="v in moduleOption.list.slice(0, 2)"
          :key="`modules-31-${v.id}`"
          class="item"
          :style="{boxShadow: `0 4px 15px 0 ${getShadowColor(path)}`}"
          @click="onModuleItem(v)"
        >
          <el-image class="item-img" :src="v.photo | imgPath" alt="order" fit="cover" />
          <div class="item-content">
            <div class="name-box">
              <p class="title h-line-1">{{ v.headline || '' }}</p>
              <p class="name h-line-1">{{ v.name || '' }}</p>
            </div>
            <p
              class="village-name"
              :style="{color: getPageThemeColor(path), backgroundColor: getPageThemeColor(path, 0.1)}"
            >{{ currentCommunity }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.title-hidden {
  visibility: visible;
}
.modules-id-31-content {
  width: 100%;
  height: 100%;
  display: flex;
}
.subtitle {
  width: 48px;
  height: 180px;
  writing-mode: vertical-lr;
  font-size: 16px;
  font-family: siyuansong;
  font-weight: 800;
  color: #CC0A66;
  letter-spacing: 2px;
  background: url('~imgs/modules/id-30-subtitle.png') no-repeat center;
  background-size: 100% 100%;
  display: grid;
  place-items: center;
}
.right-list {
  display: flex;
  column-gap: 20px;
  margin-left: 35px;
}
.item {
  width: 305px;
  height: 325px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 5px;
  .item-img {
    width: 305px;
    height: 220px;
    border-radius: 5px;
  }
}
.item-content {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 30px;
  padding-left: 20px;
  box-sizing: border-box;
  .name-box {
    font-weight: bold;
    color: #000;
    .title {
      font-size: 17px;
    }
    .name {
      font-size: 15px;
      margin-top: 20px;
    }
  }
  .village-name {
    width: 130px;
    height: 41px;
    border-radius: 5px 0 0 5px;
    font-size: 17px;
    font-weight: bold;
    text-align: center;
    line-height: 41px;
  }
}
</style>
